module.exports = __webpack_public_path__ + "static/scale-model-of-auburn-tourism-board-in-kent-washington-3e4c26dd22782197a8aa1144936ec790.png";